//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import Tags from '@product/components/Tags'

import { SEO_TAGS_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../Landing.constants'

import translations from './ProductTags.translations'

export default {
  components: {
    Tags,
    Typography,
  },
  props: {
    tags: { type: Array, required: true },
  },
  computed: {
    emptyTags() {
      return isEmpty(this.tags)
    },
    dataSelectorAttribute() {
      return SEO_TAGS_DATA_SELECTOR_ATTRIBUTE_FOR_SEO
    },
    translations: () => translations,
  },
}
